import React, { Component } from 'react';
import { Card, CardBody, CardTitle, CardText, CardLink, Button, Modal, ModalHeader, ModalBody, Col, Row } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import ModTarea from '../../Paginas/Admin/modTarea'

export default class tareaCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDelModalOpen: null,
            isModModalOpen: null,
        }

        this.toggleDel = this.toggleDel.bind(this)
        this.toggleMod = this.toggleMod.bind(this)
        this.dateToString = this.dateToString.bind(this)
    }

    toggleDel(obj) {
        this.setState({
            isDelModalOpen: obj ? obj : null
        })
    }

    toggleMod(obj) {
        this.setState({
            isModModalOpen: obj ? obj : null
        })
    }

    dateToString() {
        var date = new Date(this.props.fechaHora);
        return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }

    eliminar = (id) => {
        Fetch('/api/deleteTarea', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
            .then(response => {
                this.props.actualizarLista();
                this.toggleDel();
            })
            .catch(err => {
                switch (err.status) {
                    
                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 602:
                        console.log('Este elemento no existe')
                        break;

                    default:
                        break;
                }
            })
    }

    cambiarEstado = () => {
        const { id, completado } = this.props
        var estado = !completado
        Fetch('/api/updateCompletarTarea', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, estado })
        })
            .then(response => {
                this.props.actualizarLista();
                this.toggleDel();
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 602:
                        console.log('Este elemento no existe')
                        break;

                    default:
                        break;
                }
            })
    }



    render() {
        return (
            <div>
                <Card className="mb-1 col-12 py-2">
                    <Row><Col><Button className="p-1" close onClick={()=>this.toggleDel(this.props.id)}/></Col></Row>     
                    <CardBody>
                        <CardTitle onClick={() => this.toggleMod(this.props)} className="font-weight-bold clicable">{this.props.titulo}</CardTitle>
                        <CardText onClick={() => this.toggleMod(this.props)} className="overflow-auto text-justify clicable" style={{ height: '150px' }}>{this.props.descripcion}</CardText>
                        <CardText> {this.props.completado ? <Button className="bg-success" onClick={this.cambiarEstado} >Terminado</Button> : <Button className="bg-secondary" onClick={this.cambiarEstado} >En progreso...</Button>} </CardText>
                        <CardText>
                            <small className="text-muted">Asignada: {this.dateToString()}</small>
                        </CardText>
                    </CardBody>
                </Card>

                <Modal isOpen={this.state.isDelModalOpen !== null} toggle={this.toggleDel}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleDel()}>Eliminar</ModalHeader>
                    <ModalBody>
                    <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    ¿Esta seguro de que desea eliminar este mensaje?
                                    
                                    <CardBody>
                                        <CardLink><Button className="btn-danger" onClick={() => this.eliminar(this.state.isDelModalOpen)}>Aceptar</Button></CardLink>
                                        <CardLink><Button className="btn-light" onClick={() => this.toggleDel()}>Cancelar</Button></CardLink>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isModModalOpen !== null} toggle={() => this.toggleMod()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleMod()}>Modificar</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 border-0">
                                    <div>
                                        <ModTarea id={this.props.id} nombre={this.props.nombre} titulo={this.props.titulo} descripcion={this.props.descripcion} actualizarLista={this.props.actualizarLista} cerrar={this.toggleMod} />
                                    </div>
                                </Card>
                            </Col>

                        </Row>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}